// extracted by mini-css-extract-plugin
module.exports = {"ToDoList":"ToDoList_ToDoList__2r-Wj","ToDoList_header":"ToDoList_ToDoList_header__1ZFJP","noAssignedCards":"ToDoList_noAssignedCards__LulTT"};